import { useEffect } from "react";
import { Radio, Form, Button } from "antd";

import {
  PERMISSION_DEFAULT_VALUE,
  OPTIONS_PERMISSION,
} from "../../../../../../constant";

const TabPermissionsWealthAdmin = ({
  disableEdit,
  clientPermissions,
  handleSave,
  loading,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      manageEnterpriseAdmins:
        clientPermissions?.manageEnterpriseAdmins ?? PERMISSION_DEFAULT_VALUE,
      manageAdvisors:
        clientPermissions?.manageAdvisors ?? PERMISSION_DEFAULT_VALUE,
      manageInvestmentProducts:
        clientPermissions?.manageInvestmentProducts ?? PERMISSION_DEFAULT_VALUE,
      manageProposals:
        clientPermissions?.manageProposals ?? PERMISSION_DEFAULT_VALUE,
      resetAdvisorPasswords:
        clientPermissions?.resetAdvisorPasswords ?? PERMISSION_DEFAULT_VALUE,
      manageGlobalAdvisorFees:
        clientPermissions?.manageGlobalAdvisorFees ?? PERMISSION_DEFAULT_VALUE,
      manageMarketingContentFolders:
        clientPermissions?.manageMarketingContentFolders ??
        PERMISSION_DEFAULT_VALUE,
    });
  }, [clientPermissions]);

  return (
    <Form
      disabled={disableEdit}
      form={form}
      id="formPermissionsAdmin"
      onFinish={handleSave}
    >
      <div className="container-permission">
        <h4>Enterprise Admin Rights</h4>
        <div className="container-values">
          <Form.Item
            label="Manage Enterprise Admins"
            name="manageEnterpriseAdmins"
          >
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <div className="divider" />
          <Form.Item label="Manage Advisors" name="manageAdvisors">
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <Form.Item
            label="Manage Investment Products "
            name="manageInvestmentProducts"
          >
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <Form.Item label="Manage Proposals" name="manageProposals">
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <Form.Item
            label="Reset Advisor Passwords"
            name="resetAdvisorPasswords"
          >
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
          <Form.Item
            label="Manage Global Advisor Fees"
            name="manageGlobalAdvisorFees"
          >
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
        </div>
      </div>

      <div className="container-permission">
        <h4>Marketing Content</h4>
        <div className="container-values">
          <Form.Item
            label="Manage marketing content & folders"
            name="manageMarketingContentFolders"
          >
            <Radio.Group options={OPTIONS_PERMISSION} />
          </Form.Item>
        </div>
      </div>

      <div style={{ padding: "12px 32px" }}>
        <Button
          disabled={loading}
          htmlType="submit"
          shape="round"
          size="small"
          type="primary"
        >
          Apply Changes
        </Button>
      </div>
    </Form>
  );
};

export default TabPermissionsWealthAdmin;
